import { createTheme, type MantineColorsTuple } from '@mantine/core';

const brand: MantineColorsTuple = [
  '#e7f3fc',
  '#cfe5f6',
  '#a3ccec',
  '#73b1e2',
  '#4d9bda',
  '#358dd6',
  '#3397d7',
  '#1f78b4',
  '#136aa1',
  '#005c8e',
];

const navy: MantineColorsTuple = [
  '#eef1f4',
  '#d6dde4',
  '#aebccb',
  '#8298b0',
  '#5d7a99',
  '#46688c',
  '#385f86',
  '#274a6c',
  '#1a3d5e',
  '#0c2336',
];

export const theme = createTheme({
  primaryColor: 'brand',
  primaryShade: 6,
  colors: { brand, navy },
  black: '#0c2336',
  white: '#ffffff',
  defaultRadius: 'lg',
  fontFamily: '"DM Sans", system-ui, -apple-system, sans-serif',
  fontFamilyMonospace: '"JetBrains Mono", ui-monospace, monospace',
  headings: {
    fontFamily: '"Source Serif 4", Georgia, serif',
    fontWeight: '600',
  },
  defaultGradient: { from: 'brand.6', to: 'navy.9', deg: 135 },
  components: {
    Card: {
      defaultProps: {
        radius: 'xl',
        withBorder: true,
        shadow: 'none',
      },
    },
    Paper: {
      defaultProps: {
        radius: 'xl',
      },
    },
  },
});
